import './SchoolHero.css';

export default function SchoolHero() {
	return (
		<section className='school-hero'>
			<div className='school-hero__shape school-hero__shape--dots' />
			<div className='school-hero__shape school-hero__shape--lines' />
			<div className='school-hero__inner'>
				<h1 className='school-hero__title'>Nos formations</h1>

				<div className='school-hero__breadcrumb'>
					<a href='/'>Home</a>
					<span>/</span>
					<span>Nos formations</span>
				</div>
			</div>
		</section>
	);
}
